<template>
  <div class="l-img" :class="type">
      <div>
          <img :src="src" alt="">
      </div>
  </div>
</template>

<script>
export default {
    name: 'l-img',
    props: {
        type: {
            default:''
        },
        src:{
            default: ''
        }
    }
    
}
</script>
<style lang="scss" scoped>
.l-img{
    overflow: hidden;
    width: 100%;
    height: 100%;

    & > div{
        position: relative;
        width: 300%;
        height: 100%;
        margin-left: -100%;
        text-align: center;

    }
    img{
        margin: auto;
        height: 100%;
    }
}

.l-img.full{
    & > div{
        margin: auto;
        width: 100%;
        height: 100%;
        text-align: center;
    }

    img{
        width: 100%;
        height: 100%;
    }
}

</style>